export const switchRegionBaseUrl = (region: string) => {
  switch (region) {
    case 'KIC':
      return process.env.REACT_APP_THINQ_AUTH_SERVER_KIC;
    case 'AIC':
      return process.env.REACT_APP_THINQ_AUTH_SERVER_AIC;
    case 'EIC':
      return process.env.REACT_APP_THINQ_AUTH_SERVER_EIC;
    case 'RUIC':
      return process.env.REACT_APP_THINQ_AUTH_SERVER_RUIC;
    default:
      return process.env.REACT_APP_THINQ_AUTH_SERVER_KIC;
  }
};
